var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "he-tu-h5-chat-outer" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { ref: "scrollContainer", staticClass: "chat-content" }, [
      _c(
        "div",
        { staticClass: "chat-list" },
        _vm._l(_vm.chatList, function(item) {
          return _c(
            "div",
            { key: item.id, class: (item.bot ? "bot " : "") + "chat-item" },
            [
              item.time
                ? _c(
                    "div",
                    {
                      staticStyle: { "text-align": "center", width: "100%" },
                      attrs: { "data-tiem": item.content }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.getTimeShow(item.time)) +
                          "\n        "
                      )
                    ]
                  )
                : [
                    _c("div", { staticClass: "chat-item-image" }, [
                      _c("img", {
                        attrs: {
                          src: item.bot
                            ? require("./bot.png")
                            : require("./yonghu.png"),
                          alt: ""
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "chat-item-content-outer" }, [
                      _vm._v(_vm._s(item.name) + "\n            "),
                      _c(
                        "p",
                        { style: { textAlign: item.bot ? "left" : "right" } },
                        [
                          _vm._v(
                            _vm._s(
                              item.bot ? "知识库" : _vm.userInfo.name || ""
                            )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "chat-item-content",
                        domProps: {
                          innerHTML: _vm._s(_vm.getHtml(item.content))
                        }
                      })
                    ])
                  ]
            ],
            2
          )
        }),
        0
      )
    ]),
    _vm._v(" "),
    _c("form", { attrs: { action: "#" }, on: { submit: _vm.formSubmit } }, [
      _c(
        "div",
        { staticClass: "send-outer" },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.inputValue,
                expression: "inputValue"
              }
            ],
            staticClass: "el-input__inner innerInput",
            attrs: { placeholder: "请输入内容" },
            domProps: { value: _vm.inputValue },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.inputValue = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "send-btn",
              attrs: {
                htmlType: "button",
                disabled: !_vm.inputValue || _vm.btnDisabled
              },
              on: { click: _vm.sendTextMessage }
            },
            [_vm._v("发送")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "chat-header" }, [
      _c("img", { attrs: { src: require("./bot.png"), alt: "" } }),
      _vm._v("知识库\n  ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c8e13e9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c8e13e9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/knowledgeBase/index.vue
// module id = null
// module chunks = 